import React from "react";
import SpinnerHandler from "../../../hoc/SpinnerHandler/SpinnerHandler";
import useHttpSection from "../../../hooks/useHttpSection";
import { Link } from "react-router-dom";
import moment from "moment-jalaali";
import "./sectionStyle.scss";

const DamsTabs = {
  title: "سد ها",
  chart: "DamChart",
  values: [
    { value: "رودخانه" },
    { value: "نام سد" },
    { value: "مصارف کشاورزی" },
    { value: "مصارف شرب" },
    { value: "مصارف صنعت" },
    { value: "رهاسازی دریاچه" },
    { value: "ورودی" },
    { value: "حجم مخزن" },
  ],
  colors: [
    "#f3faf9",
    "#f4faf3",
    "#f9f3fa",
    "#faf9f3",
    "#f9f3fa",
    "#f3f8fa",
    "#f4f3fa",
    "#faf9f3",
  ],
  widths: [
    "150px",
    "140px",
    "100px",
    "150px",
    "120px",
    "120px",
    "140px",
    "140px",
  ],
  totalWidth: 1070,
  items: {
    name: 0,
    latest_update_real: {
      usage_farming_current_year: 1,
      usage_drinking_current_year: 2,
      usage_industrial_current_year: 3,
      usage_other_current_year: 4,
      input_current_year: 5,
      volume_current_year: 7,
    },
  },
};

const DamsSection = (props) => {
  const { data, isLoading } = useHttpSection(props);

  const handleDate = (item) => {
    if (item) {
      if (item.date) {
        return moment(item.date).format("jYYYY/jMM/jDD");
      } else {
        return "";
      }
    } else {
      return "";
    }
  };
  return (
    <SpinnerHandler isLoading={isLoading}>
      <div className="topHeaderContainer">
        <ul className="listTab">
          {DamsTabs.values.map((e, i) => (
            <li
              style={{
                backgroundColor: DamsTabs.colors[i],
                width: DamsTabs.widths[i],
                fontWeight: "bolder",
                fontSize: 14,
              }}
              key={e.value}
            >
              {e.value}
            </li>
          ))}
        </ul>
        <div className="line topline">
          <div></div>
        </div>
      </div>
      {data.map((item) => (
        <div className="rowContainer" key={item.id}>
          <div className="DamsRowContainer">
            <div style={{ display: "flex" }}>
              <div className="item1">{item.river_name}</div>
              <div className="item2">
                <p>{item.name}</p>
              </div>
              <div className="item3">
                <p>
                  {item.latest_update_real &&
                    item.latest_update_real.usage_farming_current_year}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update_real &&
                  (item.latest_update_real.usage_farming_current_year === 0 ||
                    item.latest_update_real.usage_farming_current_year)
                    ? handleDate(item.latest_update_real)
                    : ""}
                </p>
              </div>

              <div className="item4">
                <p>
                  {item.latest_update_real &&
                    item.latest_update_real.usage_drinking_current_year}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update_real &&
                  (item.latest_update_real.usage_drinking_current_year === 0 ||
                    item.latest_update_real.usage_drinking_current_year)
                    ? handleDate(item.latest_update_real)
                    : ""}
                </p>
              </div>
              <div className="item5">
                <p>
                  {item.latest_update_real &&
                    item.latest_update_real.usage_industrial_current_year}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update_real &&
                  (item.latest_update_real.usage_industrial_current_year === 0 ||
                    item.latest_update_real.usage_industrial_current_year)
                    ? handleDate(item.latest_update_real)
                    : ""}
                </p>
              </div>
              <div className="item6">
                <p>
                  {item.latest_update_real &&
                    item.latest_update_real.usage_other_current_year}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update_real &&
                  (item.latest_update_real.usage_other_current_year === 0 ||
                    item.latest_update_real.usage_other_current_year)
                    ? handleDate(item.latest_update_real)
                    : ""}
                </p>
              </div>
              <div className="item7">
                <p>
                  {item.latest_update_real &&
                    item.latest_update_real.input_current_year}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update_real &&
                  (item.latest_update_real.input_current_year === 0 ||
                    item.latest_update_real.input_current_year)
                    ? handleDate(item.latest_update_real)
                    : ""}
                </p>
              </div>
              <div className="item8">
                <p>
                  {item.latest_update_real &&
                    item.latest_update_real.volume_current_year}
                </p>
                <p style={{ fontSize: 10 }}>
                  {item.latest_update_real &&
                  (item.latest_update_real.volume_current_year === 0 ||
                    item.latest_update_real.volume_current_year)
                    ? handleDate(item.latest_update_real)
                    : ""}
                </p>
              </div>
            </div>
            <div className="buttonBox">
              <Link
                className="link"
                to={{
                  pathname: "DamChart",
                  state: { name: item.name, id: item.id },
                }}
              >
                <div className="buttonFullData">اطلاعات کامل</div>{" "}
              </Link>
            </div>
          </div>
          <div className="line">
            <div></div>
          </div>
        </div>
      ))}
      {!data.length && !isLoading && (
        <div className="noItemContainer">
          <p>هیچ موردی یافت نشد</p>
        </div>
      )}
    </SpinnerHandler>
  );
};

export default DamsSection;
